import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { id: "filters" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("legend", { class: "filter-header" }, "Filters", -1)
const _hoisted_3 = { class: "groups" }
const _hoisted_4 = ["for", "onKeyup"]
const _hoisted_5 = ["name", "id", "checked", "onChange"]

import { useStore } from 'vuex'
  import { computed, inject } from 'vue'
  import { groupsLoaded } from '@/core/kavelKaarten'
  import ClusterMap from '@/maps/clusterMap'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MapFilters',
  setup(__props) {

  const store = useStore()
  const maps: Promise<ClusterMap> = inject('maps')!
  const groups = computed(() => store.state.groups)

  const hasFilters = document.getElementById('digitale-kaarten-app')?.hasAttribute('data-filters')
  const selectedFilters = document.getElementById('digitale-kaarten-app')?.getAttribute('data-filters')?.split(',') ?? []


  var toggleGroup = (groupName: string): void => {
    store.commit('toggleGroup', groupName)
  }
  maps.then(map => {
    // re-define toggleGroup when maps is loaded
    toggleGroup = (groupName: string): void => {
      store.commit('toggleGroup', groupName)
      map.toggleGroup(groupName)
      const viewportMarkers: string[] = map.getMarkersInViewport()
      store.dispatch('setActiveMarkers', viewportMarkers)
    }
    if (hasFilters) {
      groupsLoaded.then(() => {
        for (const groupName in store.state.groups) {
          if (!selectedFilters.includes(groupName)) {
            toggleGroup(groupName)
          }
        }
      })
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (item, groupName) => {
        return (_openBlock(), _createElementBlock("label", {
          for: `checkbox-${groupName}`,
          class: "group-item",
          key: groupName,
          tabindex: "0",
          onKeyup: _withKeys(($event: any) => (_unref(toggleGroup)(String(groupName))), ["enter"])
        }, [
          _createElementVNode("input", {
            type: "checkbox",
            name: String(groupName),
            id: `checkbox-${groupName}`,
            checked: (groups.value[groupName].active),
            onChange: ($event: any) => (_unref(toggleGroup)(String(groupName))),
            tabindex: "-1"
          }, null, 40, _hoisted_5),
          _createElementVNode("span", {
            class: "checkmark",
            style: _normalizeStyle([
          {'border-color': `${item.color}`},
          (item.active) ? {
            'background-color': `${item.color}`,
          }: {}])
          }, null, 4),
          _createTextVNode(" " + _toDisplayString(item.name), 1)
        ], 40, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})